<template>
    <v-card elevation="0"  style="box-shadow: 0px">
        <v-card-title class="headline">Save all changes?</v-card-title>
        <v-card-actions>
            <v-btn
              color="error"
              text
              @click="$emit('discard')"
              >
            Discard
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              text
              @click="$emit('save')"
              >
            Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'LeaveDialog'
}
</script>
